// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const ResonatorsArrowsImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path className={classes.st0} d="M945.66 1441.72c.94-.54 1.71-1.89 1.71-2.99V1274.2" />
    <path className={classes.st6} d="m950.27 1276.18-2.9-10.84-2.91 10.84h5.81z" />
    <path
      className={classes.st0}
      d="M1001.21 1409.64c.94-.55 1.71-1.89 1.71-2.99V1143.6M1056.76 1377.57c.94-.54 1.71-1.89 1.71-2.99v-262.44M1112.31 1345.5c.94-.55 1.71-1.89 1.71-2.99v-262.2M1167.86 1313.43c.94-.55 1.71-1.89 1.71-2.99v-211.41M1223.41 1281.36c.94-.54 1.71-1.89 1.71-2.99v-253.49M1278.96 1249.29c.94-.55 1.71-1.89 1.71-2.99V986.68M1334.51 1217.22c.94-.54 1.71-1.89 1.71-2.99V952.29M1390.05 1185.14c.94-.55 1.71-1.89 1.71-2.99V919.6M1445.6 1153.07c.94-.54 1.71-1.89 1.71-2.99V887.52M1501.15 1121c.94-.55 1.71-1.89 1.71-2.99V855.28M1556.7 1088.93c.94-.55 1.71-1.89 1.71-2.99V823.33"
    />
  </svg>
);

export default ResonatorsArrowsImage;
